<template>
  <div v-if="raz6"> 
   <v-card outlined>
        <v-card-title>
          Razina 6
        </v-card-title>
        
          <v-data-table
              :headers="headers"
              :items="raz6Items"
              :search="search"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50]
              }"
              :items-per-page="30"
              item-key="id"
              @click:row="navigateTo"
            >
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
       
      </v-card>
  </div>
</template>

<script>

import KlasusService from '@/services/KlasusService'
export default {
  name: 'klasuslevel6',
  props:['raz1Selected','raz2Selected','raz3Selected','raz4Selected','raz5Selected'],
  data () {
    return {
      msg: '',
      items: [],
      max25chars: (v) => v.length <= 25 || 'Input too long!',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [],
      mainQuery: {},
      saving: false,
      raz6: false,
      raz6Items: [],
      raz6Selected: {},
      razUpit: {},
      showDet: false
    }
  },
  async mounted () {
     this.headers.push(
      {
        text: 'Potpuna Sifra',
        align: 'left',
        sortable: true,
        value: 'PotpunaSifra'
      },
      { text: 'Razina6', align: 'left', value: 'Razina6' },
      { text: 'Opis 6', align: 'left', value: 'Hrv6' },
      { text: 'DbId', value: 'id' }
    )
    await this.findRaz6()
  },
  methods: {
    async findRaz6() {
      let trazi = false
      if (Object.keys(this.raz1Selected).length > 0 && Object.keys(this.raz2Selected).length > 0 && Object.keys(this.raz3Selected).length > 0 && Object.keys(this.raz4Selected).length > 0 && Object.keys(this.raz5Selected).length > 0) {
        this.razUpit.Razina1 = this.raz1Selected.Razina1
        this.razUpit.Razina2 = this.raz2Selected.Razina2
        this.razUpit.Razina3 = this.raz3Selected.Razina3
        this.razUpit.Razina4 = this.raz4Selected.Razina4
        this.razUpit.Razina5 = this.raz5Selected.Razina5
        this.razUpit.onLevel = 6
        trazi = true
      }
      if (trazi) {
        await KlasusService.choose(this.razUpit).then(res => {
          if (res.data.klasusData) {
            this.raz6Items = res.data.klasusData
            this.raz6 = true
            console.log('this.raz6Items', this.raz6Items)
          }
        })
        .catch(err => {
          this.havealert = !this.havealert
          this.havemssgalert = 'Error on init Klasus Raz 6 ' + err
        })
      }
    },
    navigateTo(item) {
      console.log('Navigiram item', item)
    }
  },
  computed: {

  },
  watch: {
    'raz5Selected'() {
      if (this.raz5Selected) {
        console.log('Odabrana razina 5', this.raz5Selected)
        this.findRaz6()
      }
      if (!this.raz5Selected) {
        console.log('sad ga nemam razina 6')
        this.raz6 = false
      }
    }
  },
  components: {
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
